import React, { useState } from "react";
import Icon from "../atoms/Icon";
import EmptyS from "../atoms/EmptyS";
import { isEmpty } from "../../clases/validator";
import { Link } from "react-router-dom";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import "../../index.css";
import { API_BASE_URL } from "../../clases/request";

const Table = ({
  thData,
  onView,
  tableData,
  onMassage,
  Hempty,
  emptyText,
  onDeleteR,
  onedite,
  classOPR,
  logKey,
  logTo,
  thwidth,
  onediteS,
  onscan,
  ontick,
  deletetext,
  logtext,
  edittext,
  rowreverse,
  detailKey,
  detailTo,
  detailtext,
  onediteO,
  forbidden,
  onJson,
  Jsontext,
  editlinktext,
  editto,
  editkey,
  pageNumber,
  download,
  messages,
  datachart,
  downloadtext,
  messagestext,
  datacharttext,
  testdetail,
  notetext,
}) => {
  // Check if any operation is enabled for the table
  const hasOpperation =
    onView ||
    onMassage ||
    onDeleteR ||
    logKey ||
    detailKey ||
    onedite ||
    onediteS ||
    onscan ||
    onediteO ||
    ontick ||
    forbidden ||
    onJson ||
    editkey ||
    download ||
    messages ||
    datachart ||
    testdetail;

  // Constants
  const limit = 10;
  const token = localStorage.getItem("token");

  // Function to check if a value is numeric
  function isNumeric(value) {
    return /^-?\d+$/.test(value);
  }

  // Function to check if a text contains English or Persian characters
  function isEnglishOrPersian(text) {
    const persianRegex = /[\u0600-\u06FF\u0750-\u077F]/; // Persian character range
    const englishRegex = /[A-Za-z]/; // English character range

    if (persianRegex.test(text)) {
      return "persian";
    } else if (englishRegex.test(text)) {
      return "english";
    } else {
      // Neither English nor Persian
      return "unknown";
    }
  }

  // If tableData is empty, render an empty state component
  if (!isEmpty(tableData)) {
    return (
      <div
        className={`flex flex-col justify-center items-center  m-7.5px  ${Hempty}`}>
        <EmptyS text={emptyText} />
      </div>
    );
  } else {
    return (
      <>
        <div className="border-gray border-1 border-solid rounded-sm">
          <table className=" w-full   text-dark-blue-200 mr-.002 mt-.01">
            {/* Table header */}
            <thead className="text-13  bg-gray-300">
              <tr>
                {/* Row number column */}
                <th
                  className={`py-3.5 font-normal rounded-tl-md text-right   pl-8 pr-4 `}>
                  ردیف
                </th>
                {/* Dynamic table headers */}
                {thData.map((th) => {
                  return (
                    <th
                      className={`py-3.5 font-normal text-right first:rounded-r-sm first:pr-7.5px last:pl-7.5px ${thwidth} `}
                      key={th.key}>
                      {th.name}
                    </th>
                  );
                })
                }
                {/* Operation column if any operation is enabled */}
                {hasOpperation && (
                  <th
                    className={`py-3.5 font-normal rounded-tl-md text-right ${classOPR} w-0.1 pl-7.5px`}>
                    عملیات
                  </th>
                )}
              </tr>
            </thead>
            {/* Table body */}
            <tbody className="">
              {tableData.map((data, index) => {
                return (
                  <tr
                    key={index}
                    className="text-13 font-normal border-b-1 border-gray last:border-b-0">
                    {/* Row number */}
                    <td className="text-right pr-7">
                      {index + limit * ((pageNumber ?? 1) - 1) + 1}
                    </td>
                    {/* Dynamic table data */}
                    {thData.map((td) => {
                      return (
                        <td
                          className={` py-3.5 font-normal first:pr-7.5px ${
                            isNumeric(data[td.key]) ||
                            isEnglishOrPersian(data[td.key]) === "english"
                              ? "tracking-wider"
                              : ""
                          }`}
                          key={td.key}>
                          {data[td.key]}
                        </td>
                      );
                    })}
                    {/* Operations column */}
                    {hasOpperation && (
                      <td
                        className={`flex  pl-7.5px h-12.5 items-center justify-end gap-5  ${rowreverse}`}>
                        {/* Icons or buttons for each operation */}
                        {/* Icon for viewing used in NewOrder wich has been coommented */}
                        {onView && (
                          <Icon
                            iconName="box-search"
                            className="h-5 w-5 cursor-pointer"
                          />
                        )}
                        {/* Icon for messages */}
                        {onMassage && (
                          <Icon
                            iconName="sms-search"
                            className="h-5 w-5 cursor-pointer"
                          />
                        )}
                        {/* Icon for editing */}
                        {onedite && (
                          <Popup
                            trigger={(open) => (
                              <button className="">
                                <Icon
                                  iconName="user-edit"
                                  className="h-5 w-5 cursor-pointer"
                                  onClick={onedite}
                                  data={data.getId()}
                                />
                              </button>
                            )}
                            on={["hover", "focus"]}
                            position="top center">
                            <span> {edittext} </span>
                          </Popup>
                        )}
                        {/* Icon for editing with link to transfer to the other page */}
                        {editkey && (
                          <Popup
                            trigger={(open) => (
                              <button className="">
                                <Link
                                  to={`${editto}?${editkey}=${data.getId()}`}>
                                  <Icon
                                    iconName="edits"
                                    className="w-5 h-5 cursor-pointer"
                                  />
                                </Link>
                              </button>
                            )}
                            on={["hover", "focus"]}
                            position="top center">
                            <span> {editlinktext} </span>
                          </Popup>
                        )}
                        {/* Icon for editing used in Order page */}
                        {onediteO && (
                          <Popup
                            trigger={(open) => (
                              <button className="">
                                <Icon
                                  iconName="edits"
                                  className="w-5 h-5 cursor-pointer"
                                  onClick={onediteO}
                                  data={data.getId()}
                                />
                              </button>
                            )}
                            on={["hover", "focus"]}
                            position="top center">
                            <span> {edittext} </span>
                          </Popup>
                        )}
                        {/* Icon for link to detail page with link*/}
                        {detailKey && (
                          <Popup
                            trigger={(open) => (
                              <button className="">
                                <Link
                                  to={`${detailTo}?${detailKey}=${data.getId()}`}>
                                  <Icon
                                    iconName="document-text"
                                    className="w-5 h-5 cursor-pointer"
                                  />
                                </Link>
                              </button>
                            )}
                            on={["hover", "focus"]}
                            position="top center">
                            <span> {detailtext} </span>
                          </Popup>
                        )}
                        {/* Icon for link to detail page testing icon */}
                        {testdetail && (
                          <div className="tooltipBoundary flex">
                            <Popup
                              trigger={(open) => (
                                <button className="">
                                  <Icon
                                    iconName="note"
                                    className="w-5 h-5 cursor-pointer"
                                    onClick={testdetail}
                                    data={index}
                                  />
                                </button>
                              )}
                              on={["hover", "focus"]}
                              position="top center">
                              <span> {notetext} </span>
                            </Popup>
                          </div>
                        )}
                        {/* Icon for do enload excel file */}
                        {download && (
                          <div className="tooltipBoundary flex active-icon">
                            <Popup
                              trigger={(open) => (
                                <button className="">
                                  <Icon
                                    iconName="import"
                                    className="w-5 h-5 cursor-pointer"
                                    onClick={download}
                                    data={index}
                                  />
                                </button>
                              )}
                              on={["hover", "focus"]}
                              position="top center">
                              <span> {downloadtext} </span>
                            </Popup>
                          </div>
                        )}
                        {/* nmidonm in chie*/}
                        {messages && (
                          <div className="tooltipBoundary flex">
                            <Popup
                              trigger={(open) => (
                                <button className="">
                                  <Icon
                                    iconName="sms"
                                    className="w-5 h-5 cursor-pointer"
                                    onClick={messages}
                                    data={index}
                                  />
                                </button>
                              )}
                              on={["hover", "focus"]}
                              position="top center">
                              <span> {messagestext} </span>
                            </Popup>
                          </div>
                        )}
                        {/* Icon for grafona link */}
                        {datachart && (
                          <div className="tooltipBoundary flex">
                            <Popup
                              trigger={(open) => (
                                <button className="">
                                  <Icon
                                    iconName="diagram"
                                    className="w-5 h-5 cursor-pointer"
                                    onClick={datachart}
                                    data={index}
                                  />
                                </button>
                              )}
                              on={["hover", "focus"]}
                              position="top center">
                              <span> {datacharttext} </span>
                            </Popup>
                          </div>
                        )}
                        {/* Icon for log*/}
                        {logKey && (
                          <Popup
                            trigger={(open) => (
                              <button className="">
                                <Link to={`${logTo}?${logKey}=${data.getId()}`}>
                                  <Icon
                                    iconName="note"
                                    className="w-5 h-5 cursor-pointer"
                                  />
                                </Link>
                              </button>
                            )}
                            on={["hover", "focus"]}
                            position="top center">
                            <span> {logtext} </span>
                          </Popup>
                        )}
                        {/* Icon for Expulsion from broker */}
                        {forbidden && (
                          <Icon
                            iconName={"forbidden"}
                            className="w-5 h-5 cursor-pointer"
                            onClick={forbidden}
                            data={index}
                          />
                        )}
                        {/* Icon for json */}
                        {onJson && (
                          <div className="tooltipBoundary flex">
                            <Popup
                              trigger={(open) => (
                                <button className="">
                                  <Icon
                                    iconName="code-circle"
                                    className="w-5 h-5 cursor-pointer"
                                    onClick={onJson}
                                    data={data.getId()}
                                  />
                                </button>
                              )}
                              on={["hover", "focus"]}
                              position="top center">
                              <span> {Jsontext} </span>
                            </Popup>
                          </div>
                        )}
                        {/* Icon for delete item which is red*/}
                        {onDeleteR && (
                          <div className="tooltipBoundary flex">
                            <Popup
                              trigger={(open) => (
                                <button className="">
                                  <Icon
                                    iconName="trashR"
                                    className="w-5 h-5 cursor-pointer"
                                    onClick={onDeleteR}
                                    data={index}
                                  />
                                </button>
                              )}
                              on={["hover", "focus"]}
                              position="top center">
                              <span> {deletetext} </span>
                            </Popup>
                          </div>
                        )}
                        {/* Icon for active the guest */}
                        {ontick && (
                          <Icon
                            iconName={"tick"}
                            className="w-5 h-5 cursor-pointer"
                            onClick={ontick}
                            data={data.getId()}
                          />
                        )}
                        {/* Icon for show label scan */}
                        {onscan && (
                          <a
                            href={`${API_BASE_URL}/store-house/get-label/${data.serialNumber}/${token}`}
                            download={"kimia.png"}>
                            <Icon
                              iconName={"scan-barcode"}
                              className="w-5 h-5 cursor-pointer"
                              data={data.getId()}
                            />
                          </a>
                        )}
                        {/* Icon for edit used in Storehouse to be in order */}
                        {onediteS && (
                          <Icon
                            iconName="edits"
                            className="w-5 h-5 cursor-pointer"
                            onClick={onediteS}
                            data={data.getId()}
                          />
                        )}
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </>
    );
  }
};

export default Table;
